// ref: https://github.com/gregberge/loadable-components/issues/849#issuecomment-1105187553
export function unwrapDynamicComponent<T>(module: T | { __esModule: boolean; default: T }): T {
    if (typeof module === 'object' && '__esModule' in module && 'default' in module) {
        return module.default;
    }
    return module;
}
